import Axios from "axios";
import React, { useEffect, useState } from "react";
import { api_url } from "../../../config";
import Bouton from "../../common/HorsConnexion/Bouton";
import EcranResultat from "../../common/HorsConnexion/EcranResultat";
import { interpreterErreurLien, messageErreur } from "../../common/HorsConnexion/horsConnexion";
import PageHorsConnexion from "../../common/HorsConnexion/PageHorsConnexion";

/**
 * Activation du compte depuis le lien reçu par e-mail. Même appel qu'avant
 * (POST recipients/activate-account avec token et email), dès l'ouverture ;
 * l'écran affiche ensuite le résultat.
 */
const ActivateAccount = (props) => {
  const { token, email } = props.match.params;
  const [vue, setVue] = useState(token && email ? "chargement" : "invalide");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token || !email) return undefined;
    let demonte = false;
    Axios.post(api_url + "recipients/activate-account", { token, email })
      .then(() => {
        if (!demonte) setVue("succes");
      })
      .catch((err) => {
        if (demonte) return;
        setMessage(messageErreur(err.response && err.response.data));
        setVue(interpreterErreurLien(err));
      });
    return () => {
      demonte = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PageHorsConnexion>
      {vue === "chargement" && (
        <EcranResultat ton="attente" titre="Activation de votre compte…">
          <p>Un instant, nous vérifions votre lien.</p>
        </EcranResultat>
      )}
      {vue === "succes" && (
        <EcranResultat ton="succes" icone="coche" titre="Votre compte est activé">
          <p>Vous pouvez à présent vous connecter avec votre numéro de sécurité sociale et votre mot de passe.</p>
          <Bouton to="/">Se connecter</Bouton>
        </EcranResultat>
      )}
      {vue === "expire" && (
        <EcranResultat ton="avert" icone="horloge" titre="Ce lien a expiré">
          <p>
            Les liens d'activation sont valables <strong>3 jours</strong> après leur envoi. Celui-ci n'est
            plus utilisable.
          </p>
          <Bouton secondaire to="/">
            Retour à la connexion
          </Bouton>
        </EcranResultat>
      )}
      {vue === "utilise" && (
        <EcranResultat ton="info" icone="info" titre="Ce lien a déjà été utilisé">
          <p>Un lien d'activation ne sert qu'une fois : votre compte est très probablement déjà actif.</p>
          <Bouton to="/">Se connecter</Bouton>
        </EcranResultat>
      )}
      {(vue === "invalide" || vue === "indisponible") && (
        <EcranResultat
          ton="danger"
          icone={vue === "invalide" ? "croix" : "alerte"}
          titre={vue === "invalide" ? "Ce lien est invalide" : "Activation impossible pour le moment"}
        >
          <p>
            {vue === "invalide"
              ? "Il est peut-être tronqué ou mal recopié. Ouvrez-le directement depuis l'e-mail que vous avez reçu."
              : "Le serveur n'a pas répondu. Réessayez dans quelques instants en rouvrant le lien reçu par e-mail."}
          </p>
          {message && <p className="note">{message}</p>}
          <Bouton secondaire to="/">
            Retour à la connexion
          </Bouton>
        </EcranResultat>
      )}
    </PageHorsConnexion>
  );
};

export default ActivateAccount;
